<template>
  <div>
    <Loading
      type="line"
      :center="false"
      v-show="loading"
    />
    <b-row>
      <b-col
        cols="12"
        xl="2"
      >
        <SelectStatic
          title="Simp...Nacional"
          :required="true"
          :initialValue="configCompany.simplesNacional"
          :data="optionsSimplesNacional"
          v-model="configCompany.simplesNacional"
        />
      </b-col>
      <b-col
        cols="12"
        xl="4"
      >
        <SelectStatic
          title="Regime Tributário"
          :required="true"
          :initialValue="configCompany.regimeTributario"
          :data="optionsRegimeTributario"
          v-model="configCompany.regimeTributario"
        />
      </b-col>
      <b-col
        cols="12"
        xl="4"
      >
        <SelectStatic
          title="Regime Tributário Especial"
          :required="true"
          :initialValue="configCompany.regimeTributarioEspecial"
          :data="optionsRegimeTributarioEspecial"
          v-model="configCompany.regimeTributarioEspecial"
        />
      </b-col>
      <b-col
        cols="12"
        lg="6"
        xl="2"
      >
        <SelectStatic
          title="Incen...Cultural"
          :required="true"
          :initialValue="configCompany.incentivadorCultural"
          :data="optionsIncentivadorCultural"
          v-model="configCompany.incentivadorCultural"
        />
      </b-col>

    </b-row>
    <br>
    <Button
      _key="btnSaveCompany"
      type="success"
      title="Salvar"
      classIcon="fas fa-save"
      size="medium"
      :clicked="saveCompany"
    />
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import SelectStatic from "@nixweb/nixloc-ui/src/component/forms/SelectStatic";
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import { mapMutations, mapActions } from "vuex";

export default {
  name: "CompanyTaxation",
  components: {
    SelectStatic,
    Button,
    Loading,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      urlCreate: "/api/v1/tax-document/config-company/createOrUpdate",
      urlGetById: "/api/v1/tax-document/config-company/get-by-id",
      configCompany: {
        id: "",
        source: "tributacao",
        simplesNacional: { content: "Não", id: "false" },
        regimeTributario: { content: "Regime Normal", id: "3" },
        regimeTributarioEspecial: { content: "Nenhum", id: "0" },
        incentivadorCultural: { content: "Não", id: "false" },
      },
      optionsSimplesNacional: [
        { content: "Não", id: "false" },
        { content: "Sim", id: "true" },
      ],
      optionsIncentivadorCultural: [
        { content: "Não", id: "false" },
        { content: "Sim", id: "true" },
      ],
    };
  },
  mounted() {
    this.getById();
  },
  computed: {
    ehSimplesNacional() {
      return this.configCompany.simplesNacional.content == "Sim";
    },
    optionsRegimeTributario() {
      let optionsFinal = [];
      let options = [
        { content: "Simples Nacional", id: "1" },
        {
          content: "Simples Nacional - Excesso de Sublimite de Receita Bruta",
          id: "2",
        },
        { content: "Regime Normal", id: "3" },
        {
          content: "Simples Nacional - Microempreendedor Individual - MEI",
          id: "4",
        },
      ];

      options.forEach((option) => {
        if (
          this.ehSimplesNacional &&
          (option.id === "1" || option.id === "2" || option.id === "4")
        ) {
          optionsFinal.push(option);
        } else if (!this.ehSimplesNacional && option.id === "3") {
          optionsFinal.push(option);
        }
      });

      return optionsFinal;
    },
    optionsRegimeTributarioEspecial() {
      const options = [
        { content: "Nenhum", id: "0" },
        { content: "Microempresa Municipal", id: "1" },
        { content: "Estimativa", id: "2" },
        { content: "Sociedade de Profissionais", id: "3" },
        { content: "Cooperativa", id: "4" },
        { content: "MEI - Simples Nacional", id: "5" },
        { content: "ME EPP- Simples Nacional", id: "6" },
      ];

      let optionsFinal = [{ content: "Nenhum", id: "0" }];

      if (this.ehSimplesNacional) {
        optionsFinal.push(
          options.find((o) => o.id === "5"),
          options.find((o) => o.id === "6")
        );
      } else {
        optionsFinal.push(
          options.find((o) => o.id === "1"),
          options.find((o) => o.id === "2"),
          options.find((o) => o.id === "3"),
          options.find((o) => o.id === "4")
        );
      }

      return optionsFinal.filter(Boolean);
    },
  },
  methods: {
    ...mapActions("generic", ["postApi", "getApi"]),
    ...mapMutations("generic", ["removeLoading"]),
    getById() {
      this.loading = true;
      let params = {
        url: this.urlGetById,
        obj: {},
      };
      this.getApi(params)
        .then((response) => {
          if (response.success && response.content) {
            const data = response.content;
            this.configCompany = {
              id: data.id,
              source: "tributacao",
              simplesNacional: this.loadSelect(
                data.simplesNacional,
                "simplesNacional"
              ),
              regimeTributario: this.loadSelect(
                data.regimeTributario,
                "regimeTributario"
              ),
              regimeTributarioEspecial: this.loadSelect(
                data.regimeTributarioEspecial,
                "regimeTributarioEspecial"
              ),
              incentivadorCultural: this.loadSelect(
                data.incentivadorCultural,
                "incentivadorCultural"
              ),
            };
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveCompany() {
      this.loading = true;
      let params = { url: this.urlCreate, obj: this.configCompany };
      this.postApi(params)
        .then(() => {
          this.removeLoading(["btnSaveCompany"]);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadSelect(obj, type) {
      if (type == "simplesNacional")
        return this.optionsSimplesNacional.find((x) => x.id == obj.toString());
      if (type == "regimeTributario")
        return this.optionsRegimeTributario.find((x) => x.id == obj.toString());
      if (type == "regimeTributarioEspecial")
        return this.optionsRegimeTributarioEspecial.find(
          (x) => x.id == obj.toString()
        );
      if (type == "incentivadorCultural")
        return this.optionsIncentivadorCultural.find(
          (x) => x.id == obj.toString()
        );
    },
  },
  watch: {
    "configCompany.simplesNacional": {
      deep: true,
      handler(val) {
        if (val.content == "Sim") {
          this.configCompany.regimeTributario = {
            content: "Simples Nacional",
            id: "1",
          };
        } else {
          this.configCompany.regimeTributario = {
            content: "Regime Normal",
            id: "3",
          };
        }
      },
    },
    configCompany: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>